module.exports = __webpack_public_path__ + "static/img/wus.f70492c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wus.png
// module id = /qqJ
// module chunks = 0